<!--<mat-form-field 
  class="more__form-field" 
  appearance="outline"
  [formGroup]="form()"
>
  <mat-label
    class="ci-paragraph-p3-regular"
  >
    {{ 'Email' | translate }}
  </mat-label>
  
  <input 
    class="ci-paragraph-p3-regular"
    [formControlName]="formControlName()"
    matInput 
    type="text"
  />
  
  <mat-hint 
    class="ci-paragraph-p1-regular"
  >
    {{ 'Obligatorio' | translate }}
  </mat-hint>
</mat-form-field>-->


<div [formGroup]="form()">
  <ci-text-field-outlined 
    type="email"
    [label]="'Email' | translate"
    [placeholder]="'Email' | translate"
    required
    [supportingText]="'Obligatorio' | translate"
    [errorText]="'El campo email es obligatorio' | translate"
    (input)="handleInput($event)"
  ></ci-text-field-outlined>
</div>